import { useField } from 'formik';
import React__default from 'react';
import styled from 'styled-components';
import { setDisabledDataAttribute } from '../inputs/InputCommon.js';
import { Box } from '../layout/Box.js';
import '../layout/BulletList.js';
import { Column } from '../layout/Column.js';
import { Columns } from '../layout/Columns.js';
import '../layout/Hidden.js';
import { Inline } from '../layout/Inline.js';
import { Stack } from '../layout/Stack.js';
import '../layout/VisuallyHidden.js';
import { Text } from '../text/Text.js';
import { CSSDefaultInputField } from './common.js';
import { hasError } from './Field.js';
import { setErrorDataAttribute, FieldErrorMessage } from './FieldError.js';
import { ToggleField } from './ToggleField.js';

/**
 * Styled Components
 */ const InputBackgroundBox = styled(Box)`
  ${CSSDefaultInputField}
  padding: 0.5rem 1rem;
  cursor: pointer;
`;
const StyledText = styled(Text)`
  display: inherit;
  line-height: 1;
`;
/**
 * Extended Toggle Input with Formik Field bindings.
 * ('extended' means it displays in a similar fashion to other full width input fields - i.e.
 * `TextField` - but has the functionality of a `Toggle`)
 *
 * @example
 * <ExtendedToggleField name="chekkkers" />
 */ const ExtendedToggleField = ({ name , label , sublabel , disabled , reserveMessageSpace =true , ...props })=>{
    const [field, meta] = useField(name);
    return React__default.createElement(Stack, {
        "data-hpy-web-extended-toggle-field": true,
        ...setDisabledDataAttribute(!!disabled),
        ...setErrorDataAttribute(hasError(meta)),
        gap: 0.25
    }, React__default.createElement(InputBackgroundBox, {
        width: "fill",
        height: "fill",
        as: "label"
    }, React__default.createElement(Columns, {
        cols: 12
    }, React__default.createElement(Column, {
        col: 1,
        span: 10
    }, React__default.createElement(Box, {
        padding: !!sublabel ? 0 : [
            0.5,
            0
        ],
        height: "fill"
    }, React__default.createElement(Inline, {
        align: "left",
        alignY: "center"
    }, React__default.createElement(Stack, {
        height: "fill",
        gap: 0.125
    }, React__default.createElement(StyledText, {
        size: "medium",
        weight: "bold"
    }, label), sublabel && React__default.createElement(StyledText, {
        size: "medium"
    }, sublabel))))), React__default.createElement(Column, {
        col: 11,
        span: 2
    }, React__default.createElement(Inline, {
        width: "fill",
        align: "right",
        alignY: "center"
    }, React__default.createElement(ToggleField, {
        name: name,
        disabled: disabled,
        ...props
    }))))), React__default.createElement(FieldErrorMessage, {
        name: name,
        reserveMessageSpace: reserveMessageSpace
    }));
};
ExtendedToggleField.dataId = "data-hpy-web-extended-toggle-field";
ExtendedToggleField.displayName = "ExtendedToggleField";

export { ExtendedToggleField };
